import { IGetMyAgent } from "@/features/myAgent/interface/IGetListMyAgent";
import { IResponseFormat } from "@/interfaces/IHelper";
import services from "@/configs/axios";
import { IAgentData } from "@/interfaces/IAgentData";

export const getMyAgents = ({
  limit,
  page,
  sort,
  sort_option,
  search,
  search_option,
  is_active,
  publish_status,
  skip,
  tags,
}: IGetMyAgent) =>
  new Promise<IResponseFormat<IAgentData[]>>((resolve, reject) => {
    const data = {
      limit,
      page,
      sort,
      sort_option,
      search,
      search_option,
      is_active,
      publish_status,
      skip,
      tags,
    };
    services
      .post<IResponseFormat<IAgentData[]>>("/agents/my-agents", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
